import { createContext, Dispatch, ReactNode, SetStateAction, useEffect, useState } from 'react'

type ScrollItemType = {
    id: string;
    position: number;
}

type ScrollContextData = {
    scrollYProduct: ScrollItemType;
    setScrollYProduct: Dispatch<SetStateAction<ScrollItemType>>;
}

type ScrollContextProvider = {
    children: ReactNode
}


export const ScrollContext = createContext({} as ScrollContextData)

const ScrollContextProvider = ({ children }: ScrollContextProvider) => {
    const [scrollYProduct, setScrollYProduct] = useState({id: '', position: 0})

    return (
        <ScrollContext.Provider
            value={{
                scrollYProduct,
                setScrollYProduct,
            }}
        >
            {children}
        </ScrollContext.Provider>
    )
}

export default ScrollContextProvider